import CryptoJS from 'crypto-js';

/**
 * 检测设备类型
 * @returns {'pc' | 'android' | 'ios'} 返回设备类型标识
 */
export const checkDeviceType = () => {
  const userAgent = window.navigator.userAgent.toLowerCase();
  // 检测是否为移动端
  const isMobile = /iphone|ipad|ipod|android|windows phone|mobile/i.test(userAgent);
  if (!isMobile) {
    return 'pc';
  }
  // 检测是否为iOS设备
  if (/iphone|ipad|ipod/i.test(userAgent)) {
    return 'ios';
  }
  // 检测是否为安卓设备
  if (/android/i.test(userAgent)) {
    return 'android';
  }
  // 无法识别视为pc端
  return 'pc';
};

// 检查浏览器环境是不是在微信或者支付宝内，是其中一个就返回true，都不是则返回false
export const checkIfWxAlipay = () => {
  const userAgent = window.navigator.userAgent.toLowerCase();
  const isWeChat = /micromessenger/.test(userAgent);
  const isAlipay = /alipayclient/.test(userAgent);
  return isWeChat || isAlipay;
};

// 校验数据是否需要解密，返回true=需要解密，返回false=不需要解密
export const ifNeedDecrypt = (value) => {
  const valueType = typeof value;
  if (['boolean', 'number'].includes(valueType)) {
    return false;
  }
  if (['', null, undefined].includes(value)) {
    return false;
  }
  return true;
};

// 解密后端返回的数据
export const decryptResponse = ({ value, key, iv }) => {
  try {
    const decrypted = CryptoJS.AES.decrypt({ ciphertext: CryptoJS.enc.Base64.parse(value) }, CryptoJS.enc.Utf8.parse(key), {
      iv: CryptoJS.enc.Utf8.parse(iv),
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7,
    });
    return JSON.parse(decrypted.toString(CryptoJS.enc.Utf8));
  } catch {
    return null;
  }
};

/**
 * 复制文本到剪贴板
 * @param {string} text 需要复制的文本
 * @returns {Promise<boolean>} 返回Promise，成功为true，失败为false
 */
export const copyToClipboard = (text) => {
  // 方法1：使用现代 Clipboard API（推荐）
  if (window.navigator.clipboard && window.navigator.clipboard.writeText) {
    return window.navigator.clipboard
      .writeText(text)
      .then(() => true)
      .catch(() => false);
  }

  // 方法2：兼容旧浏览器的document.execCommand方式
  return new Promise((resolve) => {
    try {
      // 创建临时textarea元素
      const textarea = document.createElement('textarea');
      textarea.value = text;
      textarea.style.position = 'fixed'; // 防止页面滚动
      textarea.style.opacity = '0'; // 透明隐藏
      document.body.appendChild(textarea);

      // 选中文本
      textarea.select();

      // 兼容iOS设备
      if (window.navigator.userAgent.match(/ipad|iphone/i)) {
        const range = document.createRange();
        range.selectNodeContents(textarea);
        const selection = window.getSelection();
        selection.removeAllRanges();
        selection.addRange(range);
        textarea.setSelectionRange(0, 999999);
      }

      // 执行复制命令
      const success = document.execCommand('copy');
      document.body.removeChild(textarea);
      resolve(success);
    } catch (err) {
      resolve(false);
    }
  });
};

// 用a标签打开某个链接
export const openNewPage = ({ url, ifBank }) => {
  const aDom = document.createElement('a');
  aDom.href = url;
  if (ifBank) {
    aDom.target = '_bank';
  }
  document.body.appendChild(aDom);
  aDom.click();
  setTimeout(() => {
    document.body.removeChild(aDom);
  }, 0);
};
